import { z } from "zod";

import { providerIntegrationProviderSchema } from "./providerIdentity";

export const providerIngressStatusSchema = z.enum([
  "received",
  "pending",
  "processing",
  "completed",
  "dropped",
  "failed_retryable",
  "failed_terminal",
]);

export type ProviderIngressStatus = z.infer<typeof providerIngressStatusSchema>;

export const providerIngressSchema = z.object({
  enterpriseId: z.string(),
  provider: providerIntegrationProviderSchema,
  messageKey: z.string(),
  providerEventId: z.string().optional(),
  providerTaskId: z.string(),
  providerCommentId: z.string().optional(),
  providerAttachmentId: z.string().optional(),
  providerActorUserId: z.string().optional(),
  status: providerIngressStatusSchema,
  leaseOwner: z.string().optional(),
  leaseExpiresAt: z.date().nullable().optional(),
  attempts: z.number().optional(),
  rawPayloadS3Key: z.string().optional(),
  normalizedPayload: z.record(z.unknown()).optional(),
  linkedChatId: z.string().optional(),
  linkedProjectId: z.string().optional(),
  dropReason: z.string().optional(),
  lastError: z
    .object({
      message: z.string(),
      timestamp: z.date(),
    })
    .optional(),
  processedAt: z.date().optional(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type ProviderIngress = z.infer<typeof providerIngressSchema>;
